import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from './Icon.js';

var PanelWarningIcon = Icon(jsxs("g", { children: [jsx("path", { d: "M0,0H60V60H0Z", fill: "none" }), jsx("path", { d: "M52.4,2H7.6A5.593,5.593,0,0,0,2.028,7.6L2,58,13.2,46.8H52.4A5.616,5.616,0,0,0,58,41.2V7.6A5.616,5.616,0,0,0,52.4,2ZM32.8,35.6H27.2V30h5.6Zm0-11.2H27.2V13.2h5.6Z" })] }), '0 0 60 60', 'PanelWarningIcon');

export { PanelWarningIcon as default };
